export const RESIZE_HANDLE_WIDTH = 6;

export const KEYBOARD_RESIZE_STEP = 10;

export const DEFAULT_MIN_RIGHT_WIDTH = 280;

export type InitialLeftWidthConfig = {
  percent: number | null;
  min: number;
  max: number | null;
};

export const DEFAULT_INITIAL_LEFT_WIDTH: InitialLeftWidthConfig = {
  percent: 0.4,
  min: 400,
  max: null
};
